import { render } from "./OrderTask.vue?vue&type=template&id=89fc05aa&scoped=true"
import script from "./OrderTask.vue?vue&type=script&lang=js"
export * from "./OrderTask.vue?vue&type=script&lang=js"

import "./OrderTask.vue?vue&type=style&index=0&id=89fc05aa&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89fc05aa"]])

export default __exports__